import { Children } from 'react';
import type { IconToggleOrToggle } from './toggle-group-models';

type State = {
  focusedIndex: number;
  selectedIndex: number;
};

type Actions = {
  type: 'focus' | 'select';
  index: number;
};

interface InitStateArgs {
  children: IconToggleOrToggle[];
  selectedValue: string | undefined;
}

export function initState({ children, selectedValue }: InitStateArgs): State {
  const selectedIndex = Children.toArray(children).findIndex(
    (child: IconToggleOrToggle) =>
      Boolean(selectedValue) && selectedValue === child.props.value,
  );
  const focusedIndex = selectedIndex >= 0 ? selectedIndex : 0;
  return { focusedIndex, selectedIndex };
}

export function reducer(state: State, action: Actions): State {
  switch (action.type) {
    case 'focus':
      return { ...state, focusedIndex: action.index };
    case 'select':
      return {
        focusedIndex: action.index,
        selectedIndex: action.index,
      };
    default:
      throw new Error();
  }
}
